import React from "react";
import img from "../Assets/Cert.jpeg";

const IsoCertificateSection = () => {
  return (
    <div className="container my-5">
      <div className="row align-items-center">
        {/* Left Side - Certificate Image */}
        <div className="col-md-6 text-center">
          <img
            src={img}
            alt="ISO 9001:2015 Certificate"
            className="img-fluid rounded shadow"
            style={{ maxHeight: "600px" }}
          />
        </div>

        {/* Right Side - Certificate Details */}
        <div className="col-md-6">
          <p>
            <strong>
              We are proud to announce that Srimathi Manpower Consultancy
            </strong>
            has been awarded the ISO 9001:2015 certification by{" "}
            <strong>RCS CERT (Revolutionary Certification Services)</strong>.
          </p>

          <h5 className="mt-4">What is RCS CERT?</h5>
          <p>
            RCS CERT is a globally recognized, UK-accredited certification body
            that provides management system certifications across various
            industries. They ensure compliance with international standards,
            helping businesses improve quality, enhance customer satisfaction,
            and build trust.
          </p>

          <h5 className="mt-4">Our Certification Details</h5>
          <ul className="list-group">
            <li className="list-group-item">
              <strong>Scope:</strong> Manpower Services
            </li>
            <li className="list-group-item">
              <strong>Certificate No:</strong> QT-96932/0725
            </li>
            <li className="list-group-item">
              <strong>Issued On:</strong> 01 July 2025
            </li>
            <li className="list-group-item">
              <strong>Valid Until:</strong> 30 June 2028
            </li>
            <li className="list-group-item">
              <strong>Place:</strong> Chennai, India
            </li>
          </ul>

          <p className="mt-4 text-success fw-bold">
            This certification reflects our commitment to delivering
            high-quality manpower services that meet international standards.
          </p>
        </div>
      </div>
    </div>
  );
};

export default IsoCertificateSection;
